import { WritableComputedRef } from 'vue';
import { createI18n, I18n } from 'vue-i18n';

const messages: any = {};

const locales = [
    "en",
    "de",
    "zh-CN"
]

for (const locale of locales) {
    messages[locale] = require(`@/locales/${locale}`);
}

export function loadLocale(i18n: I18n, locale: string) {
    const messages = require(`@/locales/${locale}.json`);
    i18n.global.setLocaleMessage(locale, messages);
}

export function setLocale(i18n: I18n, locale: string) {
    if (!i18n.global.availableLocales.includes(locale)) {
        loadLocale(i18n, locale);
    }

    (<WritableComputedRef<string>>i18n.global.locale).value = locale;
    document.documentElement.lang = locale;
}

// export function localeName(i18n: I18n, locale: string, from?: string) {
//     return i18n.global.t("locales." + locale, {}, { locale: from ?? locale })
// }

export const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: "en",
    fallbackLocale: "en",
    availableLocales: locales,
    messages
});